import { apiClient } from './api';
import type { DashboardTemplate } from '../types/dashboard';

// Re-export the type for convenience
export type { DashboardTemplate as DashboardTemplateResponse };

export const templateService = {
  /**
   * Fetch all active dashboard templates from the API.
   * This endpoint is public (no auth required).
   */
  async getTemplates(): Promise<DashboardTemplate[]> {
    return apiClient.get<DashboardTemplate[]>('/api/dashboard-templates/');
  },

  /**
   * Fetch a single template by ID.
   */
  async getTemplate(id: number): Promise<DashboardTemplate> {
    return apiClient.get<DashboardTemplate>(`/api/dashboard-templates/${id}/`);
  },
};
